import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { Modal } from '../../../../core/services/modal';
import { Button } from "../../../ui/button/button";
import { Search } from "../../search/search";

interface MultiSelectItem {
  label: string;
  code: string;
  icon?: string;
}

@Component({
  selector: 'app-multi-select-modal',
  imports: [CommonModule, TranslatePipe, Button, Search],
  templateUrl: './multi-select-modal.html',
  styleUrl: './multi-select-modal.css'
})
export class MultiSelectModal {
  @Input() options?: {
    title?: string;
    subTitle?: string;
    placeholder?: string;
    showSearch?: boolean;
    items?: MultiSelectItem[];
    selectedValues?: MultiSelectItem[];
    onConfirm?: (selected: MultiSelectItem[]) => void;
    onClose?: () => void;
  };

  items: MultiSelectItem[] = [];
  filteredItems: MultiSelectItem[] = [];
  selectedValues: MultiSelectItem[] = [];

  constructor(private modalService: Modal) { }

  ngOnInit() {

    this.items = this.options?.items ?? [];
    this.filteredItems = [...this.items];
    this.selectedValues = Array.isArray(this.options?.selectedValues)
      ? [...this.options!.selectedValues]
      : [];
  }

  toggleSelection(item: MultiSelectItem) {
    // console.log('heree', item)
    const idx = this.selectedValues.findIndex((v) => v.code === item.code);
    if (idx >= 0) this.selectedValues.splice(idx, 1);
    else this.selectedValues.push(item);
  }

  isSelected(value: string) {
    return this.selectedValues.some((v) => v.code === value);
  }

  confirm() {
    this.options?.onConfirm?.(this.selectedValues);
    this.modalService.close();
  }

  close() {
    this.options?.onClose?.();
    this.modalService.close();
  }


  onSearchChange(value: string) {
    const search = value.toLowerCase().trim();

    this.filteredItems = search
      ? this.items.filter(item =>
        item.label.toLowerCase().includes(search)
      )
      : [...this.items];
  }

}
